import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import {
  AssessmentAIScribeResult,
  ConversationExtraction,
  TranscriptLine
} from '../../assessment-ai-scribe.model';

@Component({
  selector: 'csi-scribe-conversation-panel',
  templateUrl: './scribe-conversation-panel.component.html',
  styleUrls: ['./scribe-conversation-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScribeConversationPanelComponent {
  @Input() result: AssessmentAIScribeResult | null = null;
  @Input() errorMessage = '';

  @Output() applied = new EventEmitter<void>();
  @Output() reset = new EventEmitter<void>();

  transcriptExpanded = false;
  clinicalSummaryExpanded = false;

  get conversation(): ConversationExtraction | null {
    return this.result && this.result.conversation ? this.result.conversation : null;
  }

  get transcriptLines(): TranscriptLine[] {
    return (this.result && this.result.transcript) ? this.result.transcript : [];
  }

  get hasContent(): boolean {
    return !!this.conversation && !this.errorMessage;
  }

  speakerClass(speaker: string): string {
    if (speaker === 'doctor') return 'speaker--doctor';
    if (speaker === 'patient') return 'speaker--patient';
    return 'speaker--unknown';
  }
}
